<template>
  <v-container
    fluid
    class="pa-0"
  >
     <v-dialog
      dismissable
      max-width="600px"
      v-model="dialog"
      eager
      class="pa-0"
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          color="green"
          dark
        >
        <v-card-title class="pa-0">{{ message }}</v-card-title>
        </v-toolbar>
        <v-card-text>
          <v-icon class="green--text">mdi-check-circle</v-icon><span class="green--text">{{ message }}</span>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  export default {
    name: 'alert-success',
    props: {
      toggleDialog: {
        type: Boolean,
        default: false,
      },
      title: String,
      message: String,
    },
    data () {
      return {
        dialog: false,
      }
    },
    watch: {
      toggleDialog (val) {
        if (val) {
          this.dialog = val
        }
      },
    },
  }
</script>
